import { render, staticRenderFns } from "./Tip2.vue?vue&type=template&id=a418694e&scoped=true&lang=pug&"
import script from "./Tip2.vue?vue&type=script&lang=ts&"
export * from "./Tip2.vue?vue&type=script&lang=ts&"
import style0 from "./Tip2.vue?vue&type=style&index=0&id=a418694e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a418694e",
  null
  
)

export default component.exports